module.exports = __webpack_public_path__ + "img/35.ed12adc5.jpg";